<template>
    <shipping-info-provider v-slot="{
        campaign,
        proposal,
        contact,
        proposalStep,
        patchProposalStep,
        goNextStep,
        goPreviousStep,
        isLoading,
        isCompletingProposal,
        loadingCountries,
        loadingProvinces,
        countries,
        provinces,
        countryUpdated,
        errors,
        errorMessage
    }" style="height: 100%">
        <proposal-shipping-info-view
            :campaign="campaign"
            :proposal-step="proposalStep"
            :proposal="proposal"
            :contact="contact"
            :countries="countries"
            :provinces="provinces"
            :is-loading="isLoading"
            :errors="errors"
            :error-message="errorMessage"
            :is-completing-proposal="isCompletingProposal"
            :loading-countries="loadingCountries"
            :loading-provinces="loadingProvinces"
            @country-updated="countryUpdated"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchProposalStep"
            @chountry-updated="countryUpdated"
        />
    </shipping-info-provider>
</template>
<script>
    import ProposalShippingInfoView from "../data-views/proposals/ProposalShippingInfoView";
    import ShippingInfoProvider from "../providers/proposal-steps/ShippingInfoProvider";

    export default {
        name: "ProposalShippingRouterView",
        components: {ProposalShippingInfoView, ShippingInfoProvider}
    }
</script>
